import { css } from 'emotion'

export const UploadFilesListStyles = css`
  > li {
    padding: 8px;
  }
`
